import React, { FC } from "react";
import styled from "styled-components";
import Button from "../common/Button";
import Icon from "./Icon";
import { YELLOW_DARK, YELLOW_LIGHT } from "../styles/constants";
import { easeIn, easeOut } from "../styles/atoms";

const ReviewFilterItem: FC<{
  code: string;
  name: string;
  index: number;
  active: null | number;
  onChange: any;
  setActive: (active: null | number) => void;
}> = ({ code, name, index, active, setActive, onChange }) => {
  return (
    <Item
      key={index}
      active={index === active}
      onClick={() => {
        onChange(code);
        if (index !== active) {
          setActive(index);
        } else {
          setActive(null);
        }
      }}
    >
      {name}
      <ItemIcon code={code} size={38} />
    </Item>
  );
};

interface ItemProps {
  active: boolean;
}
const Item = styled(Button)<ItemProps>`
  z-index: 1;
  width: auto;
  position: relative;
  padding-right: 50px;
  font-size: 18px;
  flex-shrink: 0;

  &:before {
    z-index: -1;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: block;
    border-radius: inherit;
    background: linear-gradient(
      270deg,
      ${YELLOW_DARK} 0%,
      ${YELLOW_LIGHT} 97.19%
    );
    box-shadow: 0px 12px 22px #f0c20c;
    ${({ active }) => (active ? easeOut : easeIn)};
    opacity: ${({ active }) => (active ? 1 : 0)};
    content: "";
  }

  &:not(:last-child) {
    margin-right: 20px;
  }
`;

const ItemIcon = styled(Icon)`
  position: absolute;
  right: 5px;
  top: 0;
  bottom: 0;
  margin: auto;
`;

export default ReviewFilterItem;
